/**
 * Stable heading slugs (article template G2, D5): lowercase ASCII, every non-alphanumeric run → "-",
 * trimmed, at most 64 characters; non-Latin text falls back to "section". Duplicates get -2, -3, …
 * Reserved (M5): "root" would duplicate the shell's <div id="root"> (createRoot target) and "ap-…" is the
 * namespace of block ids (ap-<section>-heading); such a slug always gets a numeric suffix, and a suffixed
 * slug ends in a digit, so it can never equal a block id (those end in "-heading").
 */
const MAX_SLUG_LENGTH = 64;

export function isReservedSlug(slug: string): boolean {
  return slug === 'root' || slug.startsWith('ap-');
}

export function slugifyHeading(text: string): string {
  const slug = text
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SLUG_LENGTH)
    .replace(/-+$/g, '');
  return slug || 'section';
}

export function createSlugAllocator(): (text: string) => string {
  const used = new Set<string>();
  return (text: string) => {
    const base = slugifyHeading(text);
    let n = isReservedSlug(base) ? 2 : 1;
    let candidate = n === 1 ? base : `${base}-${n}`;
    while (used.has(candidate)) {
      n += 1;
      candidate = `${base}-${n}`;
    }
    used.add(candidate);
    return candidate;
  };
}
